import type { PropsWithChildren, ReactNode } from 'react';

export function Dialog({
  open,
  title,
  children,
  onClose,
  actions,
}: PropsWithChildren<{
  open: boolean;
  title: string;
  onClose: () => void;
  actions?: ReactNode;
}>) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <section className="dialog panel" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
        <header><h2>{title}</h2><button className="icon-btn" onClick={onClose} aria-label="Close dialog">×</button></header>
        <div className="dialog-body">{children}</div>
        {actions ? <footer>{actions}</footer> : null}
      </section>
    </div>
  );
}
